import { Attributes, ModelBase, NeoModel, Rules} from "@singularsystems/neo-core";

@NeoModel
export default class SecurityTransferLookup extends ModelBase {

    public securityTransferID: number = 0;

    @Attributes.Date()
    @Rules.Required()
    public transferEntryDate: Date | null = null;

    @Rules.Required()
    @Attributes.Display("From Stockbroker")
    public staticServiceProviderFileGroupingIDFrom: number | null = null;

    @Rules.Required()
    @Attributes.Display("To Stockbroker")
    public staticServiceProviderFileGroupingIDTo: number | null = null;

    
    public brokerAccountFrom: string = "";

    
    public brokerAccountTo: string = "";
    @Rules.Required()
    public accountFrom: string = "";
    @Rules.Required()
    public accountTo: string = "";

    @Rules.Required()
    public clientPolicyNumber: string = "";

    public clientName: string = "";

    public notes: string = "";

    public isTaxableTransferInd: boolean = false;

    @Attributes.Date()
    @Rules.Required()
    public executionDate: Date | null = null;

    public transferStatus: string = "";

    public isDeletedInd: boolean = false;

    public isExternalInd: boolean = false;
}